// extracted by mini-css-extract-plugin
module.exports = {"tradeFill":"_25ae1f54"};